import { useContext, useState } from "react";
import UiContext from "@store/ui-context";
import useAPIRequest from "@custom_hooks/simple/useAPIRequest";

export const useAPIEditJenisMobil = (props) => {
  const { onConfirmed } = props;

  const uiContext = useContext(UiContext);
  const { requestGetOne, requestPost, loading } = useAPIRequest();

  const [data, setData] = useState({});
  const [error, setError] = useState({});
  const [pengecekanPhotos, setPengecekanPhotos] = useState({
    gambar_depan: [],
    gambar_belakang: [],
    gambar_kanan: [],
    gambar_kiri: [],
  });
  const [loadingPhotos, setLoadingPhotos] = useState(false);

  //  API call section

  const fetchPengecekanPhotos = async ({ id, nama }) => {
    setLoadingPhotos(true);
    const query = id ? `id=${id}` : `nama=${encodeURIComponent(nama || "")}`;
    return requestGetOne({
      fullUrl: `/api/masterdata/jenismobil/pengecekan-photos?take=30&${query}`,
      onError: () => { },
      onSuccess: ({ data: photosData }) => {
        setPengecekanPhotos(photosData || {});
        // Auto-fill empty photo fields from the 1st candidate photo
        setData((prev) => {
          const updated = { ...prev };
          let changed = false;
          ["gambar_depan", "gambar_belakang", "gambar_kanan", "gambar_kiri"].forEach(
            (field) => {
              if (
                (!updated[field] || updated[field] === "") &&
                photosData?.[field]?.length > 0
              ) {
                updated[field] = photosData[field][0].url;
                changed = true;
              }
            }
          );
          return changed ? updated : prev;
        });
      },
    }).finally(() => {
      setLoadingPhotos(false);
    });
  };

  const fetchData = async ({ id }) => {
    return requestGetOne({
      fullUrl: `/api/masterdata/jenismobil/one/${id}`,
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
      onSuccess: ({ data: _data, message }) => {
        setData(_data);
        fetchPengecekanPhotos({ id: _data.id, nama: _data.nama });
      },
    });
  };

  const saveData = async () => {
    setError({});

    return requestPost({
      fullUrl: `/api/masterdata/jenismobil/save`,
      body: reformatDataBeforeSave(data),
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
      onSuccess: ({ data: _data, message }) => {
        uiContext.showSuccessMsg("Success", message);
        onConfirmed(_data);
      },
    });
  };

  // other function section

  const validate = () => {
    let valid = true;
    let newEror = {};

    if (!data.nama || data.nama === "") {
      newEror = { ...newEror, nama: "Nama tidak boleh kosong" };
      valid = false;
    }

    setError(newEror);
    return valid;
  };

  const reformatDataBeforeSave = (_data) => {
    const newData = data;

    return newData;
  };

  const fetchDataOrCreateNew = ({ id }) => {
    if (id && id > 0) {
      fetchData({ id });
    }
  };

  // handle ui event section

  const handleOnConfirm = () => {
    const valid = validate();
    if (valid) {
      saveData();
    }
  };

  return {
    loading,
    data,
    setData,
    error,
    pengecekanPhotos,
    loadingPhotos,
    fetchPengecekanPhotos,
    fetchDataOrCreateNew,
    handleOnConfirm,
    onConfirmed,
  };
};
